import { render, staticRenderFns } from "./BoardToast.vue?vue&type=template&id=633f6419&"
import script from "./BoardToast.vue?vue&type=script&lang=js&"
export * from "./BoardToast.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports